<div class="card">
  <div class="card-header font-weight-bold">Notes</div>
  @if (alertInfo.show) {
    <ngb-alert class="m-3" [type]="alertInfo.type" (closed)="alertInfo.show = false">
      {{ alertInfo.message }}
    </ngb-alert>
  }
  <div class="card-body">
    <div class="row">
      <div class="col-md-6">
        <form [formGroup]="notesForm">
          <textarea-field label="Add a Note" placeholder="Write your note here..."
            [textareaFormControl]="getNewNoteControl()"
          [readonly]="readonlyCustomerNotes || customer === undefined || customer === null"></textarea-field>
          @if (!readonlyCustomerNotes) {
            <button class="btn btn-success mt-2"
              [disabled]="customer === undefined || customer === null" (click)="addNote()">
              <i class="fa fa-solid fa-plus"></i> Add note
            </button>
          }
        </form>
      </div>
      <div class="col-md-6">
        <label class="font-weight-bold">Previous Notes</label>
        <div class="previous-notes">
          @for (note of previousNotes; track note; let i = $index) {
            <div class="note-item bg-light p-3 mb-1 rounded">
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <div class="fw-bold">{{ note.creator ? note?.creator?.firstName + ' ' + note?.creator?.lastName : '-----------' }} <span class="text-muted small ml-2">{{ note.createTime | date:'dd/MM/yyyy HH:mm' }}</span></div>
                </div>
                @if (readonlyCustomerNotes === false) {
                  <button class="btn btn-link text-danger p-0"
                    (click)="confirmDelete(i, 'Note', note)">
                    <i class="fa fa-trash"></i>
                  </button>
                }
              </div>
              <div class="mt-2 note-text" [innerText]="normalizeNoteText(note.note)"></div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>